import {DomainObject, oneOf} from 'shared/store';
import {t} from 'shared/core';
import {observable, action, computed} from 'mobx';
import {Employee} from 'main/stores/employees';
import {User} from 'main/stores/users';
import TimeTrackingPaySchedule from './TimeTrackingPaySchedule';
import {TimeOffType} from 'main/stores/time_off';
import {auth} from 'main/tools';

class TimeTrackingPolicy extends DomainObject {
  @observable name;
  @observable state;

  @observable overtimePolicy;
  @observable weeklyOvertimeThreshold;
  @observable dailyOvertimeThreshold;
  @observable dailyDoubleOvertimeThreshold;
  @observable weekStartDay;
  @observable sendApprovedTimesheetEditedNotification;
  @observable sendPayPeriodEndedNotification;
  @observable sendEmployeeTimesheetReminder;

  @observable paySchedule;
  @observable employees;
  @observable assigneeType;
  @observable assigneeUser;

  @observable manuallyEnterHours;

  @observable lieuTimeEnabled;
  @observable lieuTimeMultiplier;
  @observable lieuTimeDoubleMultiplier;
  @observable lieuTimePTOType;

  @observable timeClockEnabled;
  @observable collectEmployeeLocation;
  @observable timeClockLocation;
  @observable geofencingEnabled;

  @action merge(other) {
    super.merge(other, {
      paySchedule: TimeTrackingPaySchedule,
      employees: [Employee],
      assigneeUser: User,
      lieuTimePTOType: TimeOffType,
      overtimePolicy: oneOf(['standard', 'custom', 'exempt']),
      assigneeType: oneOf(['manager', 'specific_user'])
    });
  }

    @action setManuallyEnteredHours(value) {
    if (value) {
      this.merge({
        manuallyEnterHours: true,
        timeClockEnabled: false,
        collectEmployeeLocation: false,
        geofencingEnabled: false,
        timeClockLocation: null,
      });
    } else {
      this.merge({
        manuallyEnterHours: false,
        timeClockEnabled: auth.featureEnabled(':time_clock')
      });
    }
  }

  @action setTimeClockEnabled(value) {
      if (value) {
        this.merge({
          timeClockEnabled: true,
        });
      } else {
        this.merge({
          timeClockEnabled: false,
          collectEmployeeLocation: false,
          geofencingEnabled: false,
          timeClockLocation: null
        });
      }
    }

  @action setCollectEmployeeLocation(value) {
    if (value) {
      this.merge({
        collectEmployeeLocation: true,
      });
    } else {
      this.merge({
        collectEmployeeLocation: false,
        geofencingEnabled: false,
        timeClockLocation: null
      });
    }
  }

  @action setTimeClockLocation(value) {
    if (value) {
      this.merge({
        timeClockLocation: value
      });
    } else {
      this.merge({
        timeClockLocation: null,
        geofencingEnabled: false
      });
    }
  }

  @computed get hoursEnteredAsLabel() {
    return this.manuallyEnterHours ?
      t('time_tracking.manage.policies.edit.Total Hours'):
      t('time_tracking.manage.policies.edit.Start and End Time');
  }
}

export default TimeTrackingPolicy;
